import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTabs } from '@shared/hooks';
import { cn, PaletteUtils } from '@shared/utils';
import { AccountType } from '@shared/api';
import { PaymentTab, CardTab } from './widgets';
import { PageContainer } from '@widgets';
import { NoData, Spinner, Tabs } from '@shared/widgets';

export const DashboardPage = () => {
  const tabsState = useTabs({ withDebitCard: true });
  const { t } = useTranslation('dashboard');

  const currentTabView = useMemo(() => {
    if (tabsState.loading) return <Spinner />;
    if (tabsState.tab === AccountType.Payment) return <PaymentTab />;
    else if (tabsState.tab === AccountType.Card) return <CardTab />;
    else return <NoData />;
  }, [tabsState.loading, tabsState.tab]);
  return (
    <PageContainer title={t('title')} header={t('header')} showProfileName>
      <div
        className={cn(
          'flex flex-col',
          PaletteUtils.isInsigniaPalette && 'gap-12',
          PaletteUtils.isVcfcPalette && 'gap-6 max-md:gap-8 max-md:first:gap-6',
        )}
      >
        {!tabsState.loading && tabsState.hasCard && tabsState.hasPayment && (
          <Tabs options={tabsState.tabs} value={tabsState.tab!} onChange={tabsState.onChangeTab} />
        )}
        {currentTabView}
      </div>
    </PageContainer>
  );
};
